// @flow

import type { WelcomeMessage } from '../../../models'

export type State = {
  closedByUserAt: ?string,
  forceShowWelcomeMessage: boolean,
  forceShowWelcomeMessagePayload: ?string,
  welcomeMessage: ?WelcomeMessage,
  welcomeMessages: Array<WelcomeMessage>
}

export const state: State = {
  closedByUserAt: null,
  forceShowWelcomeMessage: false,
  forceShowWelcomeMessagePayload: null,
  welcomeMessage: null,
  welcomeMessages: []
}
